(function () {
  document.addEventListener("DOMContentLoaded", function () {

    /* ===================================================
       1️⃣  HANDLE REQUEST-FOR-QUOTE PAGE INJECTION
    ==================================================== */

    handleQuotePageInjection();
    waitForApoAndBuild();

    // Global APO value map
    window.apoValueMap = {};

    function waitForApoAndBuild() {
      if (window.mwApoInit && window.mwApoInit.response) {
        buildApoValueMap();
      } else {
        setTimeout(waitForApoAndBuild, 200);
      }
    }

    window.apoValueMap = {};

    function buildApoValueMap() {
      if (!window.mwApoInit || !window.mwApoInit.response) {
        console.warn("mwApoInit.response not ready");
        return;
      }

      const responses = window.mwApoInit.response;
      const map = {};

      for (const variantId in responses) {
        const variantData = responses[variantId];

        if (!variantData.values) continue;

        for (const code in variantData.values) {
          const valueObj = variantData.values[code].value;

          if (!valueObj) continue;

          map[code] = valueObj.description || valueObj.title || code;
        }
      }

      window.apoValueMap = map;

      console.log("APO VALUE MAP BUILT:", window.apoValueMap);
    }

    /* ===================================================
       2️⃣  PRODUCT PAGE LOGIC (ONLY RUNS IF EXISTS)
    ==================================================== */

    const openBtn = document.getElementById("openIntModal");
    const modal = document.getElementById("intModal");

    if (!openBtn || !modal) return; // 👈 Only product logic stops here

    let selectedSamples = [];
    let previewState = {
      fabric: { image: null, label: null },
      welt: { image: null, label: null },
    };
    const maxSamples = 6;

    const closeBtn = document.getElementById("closeintModal");
    const overlay = modal.querySelector(".int-modal-overlay");

    const fabricContainer = document.getElementById("fabricOptions");
    const weltContainer = document.getElementById("weltOptions");

    const selectedList = document.getElementById("selectedList");
    const sampleCount = document.getElementById("sampleCount");

    const previewFabric = document.getElementById("previewFabric");
    const previewWelt = document.getElementById("previewWelt");

    previewFabric.style.display = "none";
    previewWelt.style.display = "none";

    /* =============================
       MODAL OPEN / CLOSE
    ============================== */

    function openModal() {
      modal.classList.add("active");
      document.body.classList.add("int-modal-open");

      setTimeout(() => {
        initExtraction();
      }, 300);
    }

    function closeModal() {
      modal.classList.remove("active");
      document.body.classList.remove("int-modal-open");
    }

    openBtn.addEventListener("click", openModal);
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (overlay) overlay.addEventListener("click", closeModal);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("active")) {
        closeModal();
      }
    });

    /* =============================
       INIT EXTRACTION
    ============================== */

    function initExtraction() {
      fabricContainer.innerHTML = "";
      weltContainer.innerHTML = "";
      selectedSamples = [];
      previewState = {
        fabric: { image: null, label: null },
        welt: { image: null, label: null },
      };

      previewFabric.style.display = "none";
      previewWelt.style.display = "none";

      const fabrics = extractAllOptions("fabric");
      const welts = extractAllOptions("welt");

      renderOptions(fabrics, fabricContainer, "fabric");
      renderOptions(welts, weltContainer, "welt");

      renderSelected();
      updateSwatchState();
      updatePreview();
    }

    /* =============================
       EXTRACTION (UNCHANGED)
    ============================== */

    function extractAllOptions(keyword) {
      const results = [];
      const lowerKeyword = keyword.toLowerCase();

      const apoContainer = document.querySelector(".mw-apo-container");

      if (apoContainer) {
        const optionBlocks = apoContainer.querySelectorAll(".mw-option");

        optionBlocks.forEach((block) => {
          const titleEl = block.querySelector(".mw-text--style-strong");
          if (!titleEl) return;

          const title = titleEl.innerText.trim().toLowerCase();
          if (!title.includes(lowerKeyword)) return;

          const values = block.querySelectorAll(".mw-option__value");

          values.forEach((val) => {
            const input = val.querySelector("input[type='radio']");
            if (!input) return;

            const code = input.value.trim(); // v_24763252

            const img = val.querySelector(".mw-option__swatch-image");

            // 🔥 Always push — even if only code exists
            results.push({
              label: code, // temporarily store code
              code: code, // explicitly store code
              image: img ? img.src : null,
            });
          });
        });
      }

      // ===== GLOBO SUPPORT =====

      const globoGroups = document.querySelectorAll(".swatch--gl");

      globoGroups.forEach((group) => {
        const legend = group.querySelector("legend.name-option");
        if (!legend) return;

        const optionName = legend.getAttribute("data-name");
        if (!optionName) return;

        if (!optionName.toLowerCase().includes(lowerKeyword)) return;

        const items = group.querySelectorAll("li.select-option");

        items.forEach((item) => {
          const input = item.querySelector("input[type='radio']");
          const label = item.querySelector("label");
          if (!input || !label) return;

          let image = null;

          if (label.style.backgroundImage) {
            image = label.style.backgroundImage
              .replace(/^url\(["']?/, "")
              .replace(/["']?\)$/, "");
          }

          const cleanLabel = input.value.trim();

          if (!cleanLabel || cleanLabel.startsWith("v_")) return;

          results.push({
            label: cleanLabel,
            image: image,
          });
        });
      });

      return results;
    }

    /* =============================
       RENDER SWATCHES
    ============================== */

    function renderOptions(options, container, type) {
      container.innerHTML = "";

      options.forEach((opt) => {
        const div = document.createElement("div");
        div.classList.add("sample-swatch");

        div.dataset.label = opt.label;
        div.dataset.image = opt.image || "";
        div.dataset.type = type;

        // If image exists → use <img>
        if (opt.image) {
          div.innerHTML = `
      <div class="preview-btn">
        <img src="${opt.image}" alt="${opt.label}" class="swatch-img">
        </div>
        <div class="swatch-actions">
          <div class="swatch-btn add-btn">ADD</div>
        </div>
      `;
        } else {
          div.innerHTML = `
      <div class="preview-btn">
        <span class="swatch-label">${opt.label}</span>
        </div>
        <div class="swatch-actions">
          <div class="swatch-btn add-btn">ADD</div>
        </div>
      `;
        }

        container.appendChild(div);
      });
    }

    /* =============================
       GLOBAL CLICK HANDLER
    ============================== */
    document.addEventListener("click", function (e) {
      /* ---------- REMOVE SELECTED (FIRST) ---------- */
      const removeBtn = e.target.closest(".remove-selected");

      if (removeBtn) {
        const index = parseInt(removeBtn.dataset.index, 10);
        selectedSamples.splice(index, 1);
        renderSelected();
        updateSwatchState();
        updatePreview();
        return;
      }

      /* ---------- SWATCH AREA ---------- */
      const swatch = e.target.closest(".sample-swatch");
      if (!swatch) return;

      /* ---------- PREVIEW CLICK ---------- */
     if (e.target.closest(".preview-btn")) {
      const type = swatch.dataset.type;
      const rawLabel = swatch.dataset.label;

      let displayLabel = rawLabel;

      if (rawLabel && rawLabel.startsWith("v_")) {
        displayLabel = getApoReadableName(rawLabel);
      }

      let imageUrl = swatch.dataset.image;

      if (imageUrl) {
        imageUrl = imageUrl
          .replace(/width=\d+/i, "width=400")
          .replace(/height=\d+/i, "height=400");
      }

      /* 🔥 FIX START: Auto-pick fabric if welt selected first */
      if (type === "welt" && !previewState.fabric.image) {
        const firstFabric = document.querySelector(
          "#fabricOptions .sample-swatch"
        );

        if (firstFabric) {
          let fabricImage = firstFabric.dataset.image;

          if (fabricImage) {
            fabricImage = fabricImage
              .replace(/width=\d+/i, "width=400")
              .replace(/height=\d+/i, "height=400");
          }

          let fabricLabel = firstFabric.dataset.label;

          if (fabricLabel && fabricLabel.startsWith("v_")) {
            fabricLabel = getApoReadableName(fabricLabel);
          }

          previewState.fabric = {
            image: fabricImage,
            label: fabricLabel,
          };

        }
      }
      /* 🔥 FIX END */

      previewState[type] = {
        image: imageUrl,
        label: displayLabel,
      };

      updatePreview();
      return;
    }

      /* ---------- ADD CLICK ---------- */
      if (e.target.closest(".add-btn")) {
        if (selectedSamples.some((s) => s.label === swatch.dataset.label))
          return;
        const alreadySelected = selectedSamples.some(
          (s) => s.label === swatch.dataset.label,
        );

        if (alreadySelected) {
          showToast("Sample already added", "error");
          return;
        }
        if (selectedSamples.length >= maxSamples) {
          showToast("Maximum 6 samples allowed", "error");
          return;
        }

        selectedSamples.push({
          label: swatch.dataset.label,
          image: swatch.dataset.image,
          type: swatch.dataset.type,
        });

        renderSelected();
        updateSwatchState();
        return;
      }
    });

    function showToast(message, type = "error") {
      const toast = document.getElementById("intErrorMessage");

      toast.textContent = message;
      toast.className = `toast-message ${type} show`;

      setTimeout(() => {
        toast.classList.remove("show");
      }, 3000);
    }

    function updateSwatchState() {
      document.querySelectorAll(".sample-swatch").forEach((swatch) => {
        const isSelected = selectedSamples.some(
          (item) => item.label === swatch.dataset.label,
        );

        const addBtn = swatch.querySelector(".add-btn");

        if (isSelected) {
          swatch.classList.add("is-selected");
          if (addBtn) addBtn.innerText = "ADDED";
        } else {
          swatch.classList.remove("is-selected");
          if (addBtn) addBtn.innerText = "ADD";
        }
      });
    }
    /* =============================
       CONTINUE BUTTON
    ============================== */

    const continueBtn = document.getElementById("continueSamples");

    continueBtn.addEventListener("click", function () {
      if (selectedSamples.length === 0) {
        alert("Please select at least one sample");
        return;
      }

      const formattedSamples = selectedSamples
        .map((item) => {
          if (!item.label.startsWith("v_")) {
            return item.label.trim();
          }

          const readable = getApoReadableName(item.label).replace(/\n/g, " ");
          return `${readable} (${item.label})`;
        })
        .join(" | ");

      sessionStorage.setItem("selectedSamplesText", formattedSamples);

      const productId = openBtn.dataset.productId;

      if (window.GRFQApp && typeof GRFQApp.addProduct === "function") {
        GRFQApp.addProduct(document.querySelector(".int-modal-btn"), productId);
      }
    });

    function getApoReadableName(code) {
      if (!window.mwApoInit || !window.mwApoInit.response) {
        return code;
      }

      const responses = window.mwApoInit.response;

      console.log("Checking code:", code);
      console.log("Responses:", window.mwApoInit.response);

      // Loop through variants safely
      for (const variantId in responses) {
        const variantData = responses[variantId];

        if (
          variantData &&
          variantData.values &&
          variantData.values[code] &&
          variantData.values[code].value
        ) {
          const valueObj = variantData.values[code].value;

          // Use full description
          if (valueObj.description) {
            return valueObj.description;
          }

          // Fallback to title
          if (valueObj.title) {
            return valueObj.title;
          }
        }
      }

      return code;
    }

    /* =============================
       RENDER SELECTED
    ============================== */

    function renderSelected() {
      selectedList.innerHTML = "";

      if (selectedSamples.length === 0) {
        selectedList.innerHTML = `
      <div class="add-swatch-box">
        <span class="add-swatch">Click Add below swatches to select</span>
      </div>
    `;
      } else {
        selectedSamples.forEach((item, index) => {
          const div = document.createElement("div");
          div.classList.add("selected-item");

          let displayLabel = item.label;

          if (item.label.startsWith("v_")) {
            displayLabel = getApoReadableName(item.label);
          }

          div.innerHTML = `
        <img src="${item.image}" alt="${displayLabel}">
        <div class="remove-selected" data-index="${index}">×</div>
        <p>${displayLabel}</p>
      `;

          selectedList.appendChild(div);
        });
      }

      // Update counter
      sampleCount.innerText = selectedSamples.length;

      // Optional: disable continue button if empty
      const continueBtn = document.getElementById("continueSamples");
      if (continueBtn) {
        continueBtn.disabled = selectedSamples.length === 0;
      }
    }

    function updatePreview() {
      // Fabric image
      previewFabric.src = previewState.fabric.image || "";
      previewFabric.style.display = previewState.fabric.image
        ? "block"
        : "none";

      // Welt image
      previewWelt.src = previewState.welt.image || "";
      previewWelt.style.display = previewState.welt.image ? "block" : "none";

      updatePreviewText();
      updatePreviewVisibility();
    }

    function updatePreviewText() {

      const previewContentDiv = document.querySelector(".preview-content");

      const fabricRow = document.querySelector(".main-fabric-text")?.closest("p");
      const weltRow = document.querySelector(".welting-fabric-text")?.closest("p");

      const fabricLabel = previewState.fabric?.label;
      const weltLabel = previewState.welt?.label;

      if (!fabricLabel && !weltLabel) {
        previewContentDiv.style.display = "none";
        return;
      }

      previewContentDiv.style.display = "block";

      if (fabricLabel) {
        document.querySelector(".main-fabric-text").textContent = fabricLabel;
        fabricRow.style.display = "block";
      } else {
        fabricRow.style.display = "none";
      }

      if (weltLabel) {
        document.querySelector(".welting-fabric-text").textContent = weltLabel;
        weltRow.style.display = "block";
      } else {
        weltRow.style.display = "none";
      }
    }

    function updatePreviewVisibility() {
      const previewSection = document.querySelector(".preview-section");
      const fabricImg = document.getElementById("previewFabric");
      const weltImg = document.getElementById("previewWelt");

      const fabricAdded =
        fabricImg && fabricImg.src && fabricImg.style.display !== "none";
      const weltAdded =
        weltImg && weltImg.src && weltImg.style.display !== "none";

      if (fabricAdded || weltAdded) {
        previewSection.style.display = "flex";
      } else {
        previewSection.style.display = "none";
      }
    }
  });

  /* ===================================================
     QUOTE PAGE INJECTION FUNCTION (GLOBAL)
  ==================================================== */

  function handleQuotePageInjection() {
    const storedSamples = sessionStorage.getItem("selectedSamplesText");
    if (!storedSamples) return;

    const samplesText = `Requested Samples:\n\n${storedSamples}`;

    const observer = new MutationObserver(() => {
      const messageField =
        document.querySelector("#textarea__1772516154558") ||
        document.querySelector("textarea[name='textarea__1772516154558']");

      if (messageField) {
        messageField.setAttribute("tabindex", "-1");
        messageField.setAttribute("readonly", "readonly");

        if (!messageField.value.includes(samplesText)) {
          const existingText = messageField.value.trim();

          messageField.value = existingText
            ? samplesText + "\n\n" + existingText
            : samplesText;

          messageField.dispatchEvent(new Event("input", { bubbles: true }));
        }

        sessionStorage.removeItem("selectedSamplesText");
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
